/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExecutionJob } from '../models/ExecutionJob';
import type { ExecutionJobCollection } from '../models/ExecutionJobCollection';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExecutionJobsService {
    /**
     * List execution jobs with optional filtering
     * @returns ExecutionJobCollection List of execution jobs
     * @throws ApiError
     */
    public static listExecutionJobs({
        type,
        status,
        pageToken,
        pageSize,
        resourceType,
        resourceId,
    }: {
        type?: string,
        status?: string,
        pageToken?: string,
        pageSize?: number,
        resourceType?: string,
        resourceId?: string,
    }): CancelablePromise<ExecutionJobCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/executionJobs',
            query: {
                'type': type,
                'status': status,
                'pageToken': pageToken,
                'pageSize': pageSize,
                'resourceType': resourceType,
                'resourceId': resourceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get execution job details
     * @returns ExecutionJob Execution job details
     * @throws ApiError
     */
    public static getExecutionJob({
        executionJobId,
    }: {
        executionJobId: string,
    }): CancelablePromise<ExecutionJob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/executionJobs/{executionJobId}',
            path: {
                'executionJobId': executionJobId,
            },
            errors: {
                404: `Execution job not found`,
                500: `Internal server error`,
            },
        });
    }
}
